import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Helpers } from '../../../utility/helpers';
import { dispatchSetTo } from '../../common/hooks/useCncFlyInState';
import { useAppDispatch } from '../../common/hooks/useThunkDispatch';
import { CncStep } from '../../common/store/structureDefinitions/uiState';

export const OPEN_CART_QUERY_TRIGGER = 'opencart';

const useOpenCartQueryTrigger = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        if (Helpers.getParameterByName(OPEN_CART_QUERY_TRIGGER)) {
            dispatch(
                dispatchSetTo({
                    step: CncStep.MiniCart,
                }),
            );
            navigate({ search: undefined }, { replace: true });
        }
    }, [dispatch, navigate]);
};

export const useEcommerceQueryStringTriggers = () => {
    useOpenCartQueryTrigger();
};
